import Vue from 'vue'

import AppBtn from '../app-btn'
import AppMenuMobile from '../app-menu-mobile'
import AppTextMask from '../app-text-mask'

import CoreResize from '../../mixins/core-resize'

import URL from '../../../config.url'

import { getSafe } from '../../utils/Object'

export default
{
    name: 'app-menu',

    mixins:
    [
        CoreResize
    ],

    components:
    {
        AppBtn,
        AppMenuMobile,
        AppTextMask
    },

    props:
    {
        contentGlobal: {type: Object},
        contentPage: {type: Object}
    },

    data()
    {
        return {
            pagesURL: URL.page,
            currentURL: '/',
            rowOver: {},

            isMenuOpen: false,

            navLevel: 0, // 0 = home page...

            prevPageURL: this.$root.getPageURLFromID('home'),
            prevPageLabel: this.contentGlobal.mainMenu.home,

            itemsAreHidden: false
        }
    },

    watch:
    {
        contentPage: '_changeLinks'
    },

    created()
    {
        // this._setData()
        this.currentURL = this.$root.$route.path
        this.eventHub.$on('route:change', this._onRouteChange)
        this.eventHub.$on('menu:hide-items', this._hideItems)
        this.eventHub.$on('menu:show-items', this._showItems)
    },

    mounted()
    {
        const row = this.$el.querySelectorAll('.js-menu>li[data-menu=true]')
        for (const key in row)
        {
            if (Object.prototype.hasOwnProperty.call(row, key))
            {
                const elmt = row[key]
                elmt.addEventListener('mouseenter', this._onRowOver)
                elmt.addEventListener('mouseleave', this._onRowOut)
            }
        }
    },

    destroyed()
    {
        this.eventHub.$off('menu:hide-items', this._hideItems)
        this.eventHub.$off('menu:show-items', this._showItems)

        const row = this.$el.querySelectorAll('.js-menu>li[data-menu=true]')
        for (const key in row)
        {
            if (Object.prototype.hasOwnProperty.call(row, key))
            {
                const elmt = row[key]
                elmt.removeEventListener('mouseenter', this._onRowOver)
                elmt.removeEventListener('mouseleave', this._onRowOut)
            }
        }
    },

    methods:
    {
        _getPageURL(page)
        {
            return this.$root.getPageURLFromID(page.pageLabel,
                {
                    slug: getSafe(() => page.slug)
                })
        },

        _hideItems()
        {
            this.itemsAreHidden = true
        },

        _showItems()
        {
            this.itemsAreHidden = false
        },

        onResized(w)
        {
            if (w > 940 && this.isMenuOpen)
            {
                this.isMenuOpen = false
            }
        },

        pushBuyToGTM()
        {
            if (window.dataLayer)
            {
                window.dataLayer.push({
                    event: 'gfinity.external',
                    'gfinity.external.type': 'click',
                    'gfinity.external.resource': this.contentGlobal.mainMenu.buy.href
                })
            }
            else
            {
                console.error('Google Tag Manager: dataLayer not defined')
            }
        },

        _openModalPlay()
        {
            this.$root.openModalPlay('default')
        },

        _toggleMenu()
        {
            this.isMenuOpen = !this.isMenuOpen
            if (!this.isMenuOpen)
            {
                this.eventHub.$emit('page-size-dispatch')
            }
        },

        _toggleSubMenu(id)
        {
            // Toggle menu on click only for touch support
            if (this.$root.isTouch)
            {
                this.rowOver[id] = !!this.rowOver[id]
            }
        },

        _onRowOver(event)
        {
            const id = event.target.dataset.id
            Vue.set(this.rowOver, id, true)
        },

        _onRowOut(event)
        {
            const id = event.target.dataset.id
            Vue.set(this.rowOver, id, false)
        },

        _changeLinks()
        {
            switch (this.$route.meta.component)
            {
            case 'page-match-details' :

                this.prevPageURL = this.$root.getPageURLFromID('esMatches')
                this.prevPageLabel = this.contentGlobal.mainMenu.back
                this.navLevel = 1
                break

            case 'page-team-profile' :

                this.prevPageURL = this.$root.getPageURLFromID('teams')
                this.prevPageLabel = this.contentGlobal.mainMenu.back
                this.navLevel = 2
                break

            case 'page-player' :

                if (this.contentPage && this.contentPage.team && this.contentPage.team.slug)
                {
                    this.prevPageURL = this.$root.getPageURLFromID('teamProfile').replace(':slug', this.contentPage.team.slug)
                }
                else
                {
                    this.prevPageURL = this.$root.getPageURLFromID('teams')
                }
                this.prevPageLabel = this.contentGlobal.mainMenu.back
                this.navLevel = 2
                break

            case 'page-article' :

                this.prevPageURL = this.$root.getPageURLFromID('news')
                this.prevPageLabel = this.contentGlobal.mainMenu.back
                this.navLevel = 2
                break

            case 'page-video-player' :

                this.prevPageURL = this.$root.getPageURLFromID('videos')
                this.prevPageLabel = this.contentGlobal.mainMenu.back
                this.navLevel = 2
                break

            default :

                this.prevPageURL = this.$root.getPageURLFromID('home')
                this.prevPageLabel = this.contentGlobal.mainMenu.home
                this.navLevel = 1
                break
            }
        },

        _onRouteChange(route)
        {
            this.currentURL = route.path

            for (const key in this.rowOver)
            {
                if (this.rowOver[key])
                {
                    this.rowOver[key] = false
                }
            }

            if (this.isMenuOpen)
            {
                this.isMenuOpen = false
            }
        },

        _goHome(event)
        {
            this.currentURL = null
            this.$root.changePage(this.$root.getPageURLFromID('home'))

            event.preventDefault()
            return false
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-menu/script.js